// Post-W4 (Avaturn deprecation): catalog (prerendered MetaPerson) avatars
// are free for all plans. Premium adds dynamic MP generation + IVC voice
// clone, but that's gated separately from the avatar-render path.
//
// The `"avaturn"` literal is retained in the type union ONLY so the 5
// FROZEN avatar files (AvatarCore / AvatarViewer / MirrorAvatar /
// mirrorAvatarConfig / AvatarCard) keep compiling — their dead-branch
// `if (provider === "avaturn")` checks are intentionally not cleaned up.
// No runtime code returns or writes "avaturn" anymore.
type Provider = "avaturn" | "metaperson" | "none";

export function getEffectiveAvatarProvider(
  _plan: string,
  storedProvider: string | null,
): Provider {
  if (!storedProvider || storedProvider === "none") return "none";
  if (storedProvider === "metaperson") return "metaperson";
  // Legacy "avaturn" rows shouldn't exist post-Sub-task B's bulk update,
  // but if any slipped through, treat them as "none" (orb fallback) rather
  // than rendering a defunct provider.
  return "none";
}

// Kept for ABI stability with potential downstream imports. Post-W4 there is
// no plan-based provider gating at the avatar-render layer.
export function canUseProvider(
  _plan: string,
  _provider: "avaturn" | "metaperson",
): boolean {
  return true;
}
